import { render, staticRenderFns } from "./Associado-Detalhe.vue?vue&type=template&id=60b56cd2&scoped=true"
import script from "./Associado-Detalhe.vue?vue&type=script&lang=js"
export * from "./Associado-Detalhe.vue?vue&type=script&lang=js"
import style0 from "./Associado-Detalhe.vue?vue&type=style&index=0&id=60b56cd2&prod&scoped=true&lang=scss"
import style1 from "./Associado-Detalhe.vue?vue&type=style&index=1&id=60b56cd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b56cd2",
  null
  
)

export default component.exports